import { render, staticRenderFns } from "./MedalSvg.vue?vue&type=template&id=48247db6&"
import script from "./MedalSvg.vue?vue&type=script&lang=js&"
export * from "./MedalSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports